module.exports = __webpack_public_path__ + "static/media/microsoft-technologies.4dda0c7c.png";